export function normalizePhone(raw: string): string {
  const digits = raw.replace(/\D/g, "");
  const withoutLeading = digits.startsWith("7") ? digits.slice(1) : digits.startsWith("8") ? digits.slice(1) : digits;
  return `+7${withoutLeading}`.slice(0, 12);
}

export function isValidKzPhone(phone: string): boolean {
  return /^\+7\d{10}$/.test(phone);
}

export function formatPhoneDisplay(phone: string): string {
  const m = phone.match(/^\+7(\d{3})(\d{3})(\d{2})(\d{2})$/);
  if (!m) return phone;
  return `+7 ${m[1]} ${m[2]}-${m[3]}-${m[4]}`;
}
